import { render, staticRenderFns } from "./RTPSettings.vue?vue&type=template&id=4b8f3c38&"
import script from "./RTPSettings.vue?vue&type=script&lang=js&"
export * from "./RTPSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8f3c38')) {
      api.createRecord('4b8f3c38', component.options)
    } else {
      api.reload('4b8f3c38', component.options)
    }
    module.hot.accept("./RTPSettings.vue?vue&type=template&id=4b8f3c38&", function () {
      api.rerender('4b8f3c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/RTPSettings.vue"
export default component.exports